import React from "react";
import BlurLoading from "../../../Components/BlurLoading";
import { getProviderInitials, getProviderTheme } from "../constants";
import {
  formatAutomatedBillStatus,
  isDisplayableAutomatedBillValue,
} from "./automatedBillsUtils";

function buildFields(item) {
  return [
    { label: "Amount", value: item?.amount || item?.Amount },
    { label: "Frequency", value: item?.frequency || item?.Frequency },
    {
      label: "Next Payment",
      value: item?.nextPaymentDate || item?.NextPayment || item?.nextPayment,
    },
  ].filter((field) => isDisplayableAutomatedBillValue(field.value));
}

export default function AutomatedBillCard({
  bill,
  loading = false,
  onToggleStatus,
}) {
  const theme = getProviderTheme(bill?.providerName || bill?.ProviderName);
  const status = formatAutomatedBillStatus(bill?.status || bill?.Status);
  const fields = buildFields(bill);
  const actionLabel = bill?.isChecked ? "Pause" : "Resume";
  const reference =
    bill?.mobileNumber || bill?.Reference || bill?.PhoneNumber || bill?.Identifier;
  const hasReference = isDisplayableAutomatedBillValue(reference);

  return (
    <article
      className="bills-page__automation-card card h-100"
      style={{
        "--bill-accent": theme.accent,
        "--bill-surface": theme.surface,
      }}
    >
      <div className="bills-page__automation-header d-flex justify-content-between align-items-start gap-3">
        <div className="bills-page__automation-provider d-flex align-items-center gap-3">
          <div className="bills-page__automation-badge">
            {bill?.providerImage || bill?.Image ? (
              <img
                src={bill?.providerImage || bill?.Image}
                alt={bill?.providerName || bill?.Title || bill?.ProviderName || "Provider"}
              />
            ) : (
              <span>{getProviderInitials(bill?.providerName || bill?.Title || bill?.ProviderName)}</span>
            )}
          </div>
          <div>
            <h3>{bill?.providerName || bill?.Title || bill?.ProviderName || "Automated bill"}</h3>
            {hasReference ? <p>{reference}</p> : null}
          </div>
        </div>
        <span
          className={`bills-page__status-pill is-${String(status).toLowerCase()}`}
        >
          {status}
        </span>
      </div>

      {fields.length > 0 ? (
        <dl className="bills-page__automation-fields mb-0">
          {fields.map((field) => (
            <div key={field.label} className="d-flex justify-content-between gap-3">
              <dt>{field.label}</dt>
              <dd>{field.value}</dd>
            </div>
          ))}
        </dl>
      ) : null}

      {hasReference ? (
        <div className="bills-page__automation-actions">
          <button
            type="button"
            className="bills-page__automation-edit"
            disabled={loading}
            onClick={() => onToggleStatus?.(bill, !bill?.isChecked)}
          >
            {actionLabel}
          </button>
        </div>
      ) : null}

      <BlurLoading show={loading} />
    </article>
  );
}
